import { render, staticRenderFns } from "./PdpStickyHeader.vue?vue&type=template&id=4ddd1ca0&scoped=true&"
import script from "./PdpStickyHeader.vue?vue&type=script&lang=js&"
export * from "./PdpStickyHeader.vue?vue&type=script&lang=js&"
import style0 from "./PdpStickyHeader.vue?vue&type=style&index=0&id=4ddd1ca0&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddd1ca0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShopifyImage: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/ShopifyImage.vue').default})
